import { render, staticRenderFns } from "./Reklamationsgrund.vue?vue&type=template&id=2cae3416&scoped=true&"
import script from "./Reklamationsgrund.vue?vue&type=script&lang=js&"
export * from "./Reklamationsgrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae3416",
  null
  
)

export default component.exports